import { createFeatureSelector, createSelector } from '@ngrx/store';

import { boilersSelectorKey, type BoilersState } from './boilers.reducer';

export const selectBoilersFeature =
  createFeatureSelector<BoilersState>(boilersSelectorKey);

export const selectBoilersAdviceFormSubmitStatus = createSelector(
  selectBoilersFeature,
  (state) => state.adviceFormSubmitStatus.status
);

export const selectBoilersAdviceFormSubmitRedirect = createSelector(
  selectBoilersFeature,
  (state) => state.adviceFormRedirectUrl
);

export const selectSelectedProduct = createSelector(
  selectBoilersFeature,
  (state) => state.selectedProduct
);
